module.exports = __webpack_public_path__ + "static/media/kdrm.11a8f010.png";